export default "__VITE_PUBLIC_ASSET__1d88e8a6__"